import React, { createContext, useContext } from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { Translates } from '@/services/repository/i18n'

export interface AppContextType {
  services: Services
  session: CurrentSession | null | undefined
  translates?: Translates
}

export const AppContext = createContext<AppContextType | undefined>(undefined)

export function useAppContext() {
  const ctx = useContext(AppContext)
  if (!ctx) throw new Error('useAppContext must be used within AppContext.Provider')
  return ctx
}